<style scoped="scoped" lang="scss">
.work {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 10px;
  margin-left: 50px;
  width: 344px;
  height: 150px;
  background: #f4f4f5;
  border-radius: 4px;
  flex: none;
  order: 5;
  flex-grow: 0;
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/production/config/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shengchanpeizhileixing')">
            <yi_dictionary_select type="PRODUCTION_CONFIG_TYPE" :ids.sync="yt.conditions.type"></yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear(orderBy)">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" v-if="utils.checkPower('web_system_configuration_create')" @click="yt.showEditDialog('xinzeng', null, 'w2', beforeShowEditDialog)" type="primary">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #shifouqiyong="scope">
        {{ scope.row.status == 1 ? $t('shi') : $t('fou') }}
      </template>

      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" v-if="utils.checkPower('web_system_configuration_update')" @click="yt.showEditDialog('bianji', scope.row, 'w2', beforeShowEditDialog)">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" v-if="utils.checkPower('web_system_configuration_delete')" class="font-color-danger" @click="yt.remove(scope.row, '/web/production/config/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'xinzeng'">
        <div class="dialog-scroller">
          <!--          {{store.state.dictJsonAll['PRODUCTION_CONFIG_TYPE'][yt.editObj.type]}}-->
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('shengchanpeizhileixing')">
              <yi_dictionary_select type="PRODUCTION_CONFIG_TYPE" :ids.sync="yt.editObj.type" @change="dictionaryChange(yt.editObj.type)"></yi_dictionary_select>
            </el-form-item>

            <div v-if="yt.editObj.type === '0'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <p style="font-size: 18px;">{{ $t('peizhixinxi') }}</p>
              <el-form-item style="margin-left: -30px;" :label="$t('juese')" label-width="130px" required></el-form-item>
              <el-form-item style="margin-left: 150px;" :label="$t('baogongjiange(xiaoshi)')" label-width="130px" required></el-form-item>
              <el-form-item style="margin-left: 70px;" :label="$t('jiangexiaoguo')" label-width="105px" required></el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '1'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <el-form-item :label="$t('chaochanleixing')" required>
                <el-select v-model="yt.editObj.overType">
                  <el-option :label="$t('bili')" :value="0"></el-option>
                  <el-option :label="$t('shuliang')" :value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('chaochanzhi')" required>
                <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.overValue" size="mini"></el-input>
              </el-form-item>
              <p class="work">
                <i style="margin-left: -270px;" class="yicon yicon-tips">{{ $t('shilishuoming') }}</i>
                <span>{{ $t('bilishuoming') }}</span>
                <span>{{ $t('shuliangshuoming') }}</span>
              </p>
            </div>
            <div v-else-if="defaultTypeList.indexOf(yt.editObj.type) > -1">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '3'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '4'">
              <el-form-item :label="$t('mujuzhuangtai')" required>
                <yi_dictionary_select :max="999" multiple :type="'BASIC_MOULD_STATUS'" :ids.sync="yt.editObj.mouldStatus"></yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>

            <div v-else-if="yt.editObj.type === '7'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <!--工单限制数量，0或者无不限制数量              -->
              <el-form-item :label="$t('gongdanxianzhishuliang')">
                <el-input-number v-model="configJson.limitNum"></el-input-number>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '11'">
              <el-form-item :label="$t('gongdanzhuangtai')" required>
                <yi_dictionary_select :max="8" multiple :type="'PRODUCTION_WO_STATUS'" :ids.sync="yt.editObj.woStatus"></yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>

            <div v-else-if="yt.editObj.type === '12'">
              <el-form-item :label="$t('gongdanyouxianji')" required>
                <el-select v-model="yt.editObj.woStartPriority" @change="$forceUpdate()">
                  <el-option :label="$t('gongdanshunxu')" value="0"></el-option>
                  <el-option :label="$t('jihuakaishishijian')" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '13'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '15'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('zuidazhangshu') + '(1-50)'" required>
                <el-input-number :min="1" :max="50" step-strictly v-model="yt.editObj.overValue"></el-input-number>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>

            <div v-else-if="yt.editObj.type === '22'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('shebeimingcheng')">
                <el-row>
                  <el-col :span="20">
                    <yi_data_select ref="equipmentSelect" :multiple="true" :type="'equipment'" :ids.sync="yt.editObj.equipmentIds"></yi_data_select>
                  </el-col>
                  <el-col :span="4">
                    <el-button type="text" @click="selectAll()">{{ $t('quanxuan') }}</el-button>
                  </el-col>
                </el-row>
              </el-form-item>

              <el-form-item :label="$t('baogongren')">
                <yi_data_select :type="'customer_user'" :ids.sync="configJson.reportId"></yi_data_select>
              </el-form-item>

              <el-form-item :label="$t('自动计算产量')">
                <el-checkbox v-model="configJson.checked"></el-checkbox>
              </el-form-item>

              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>

            <div v-else-if="yt.editObj.type === '24'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>

            <div v-else-if="yt.editObj.type === '25'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '29'">
              <el-form-item :label="$t('tongzhiyonghu')" required>
                <yi_data_select :multiple="true" :type="'customer_user'" :ids.sync="yt.editObj.equipmentIds"></yi_data_select>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '31'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <div v-if="yt.editObj.status === 1">
                <el-form-item :label="$t('xieyi')">
                  <el-select v-model="configJson.protocol" style="flex: 1;">
                    <el-option v-for="(h, i) in ['http://', 'https://']" :key="i" :label="h" :value="h"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('zhuji')">
                  <el-input style="flex: 4;" type="text" placeholder="ip:port" v-model="configJson.host"></el-input>
                </el-form-item>
                <el-form-item label="AppKey">
                  <el-input type="text" v-model="configJson.appKey"></el-input>
                </el-form-item>
                <el-form-item label="AppSecret">
                  <el-input type="text" v-model="configJson.appSecret"></el-input>
                </el-form-item>
                <el-form-item :label="$t('jiekoushangxiawenlujin')">
                  <el-input type="text" v-model="configJson.contextPath" placeholder="/"></el-input>
                </el-form-item>
                <el-form-item :label="$t('jiankongdianweiyibiaoshi')">
                  <div style="display: flex;">
                    <el-input type="text" v-model="configJson.indexCode"></el-input>
                    <el-tooltip :content="$t('duogeyongdouhaogekai')" placement="right" style="margin: auto 5px;">
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </div>
                </el-form-item>
              </div>
            </div>
            <div v-else-if="yt.editObj.type === '33'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <p style="font-size: 16px; margin: 0 70px 20px">{{ $t('gongdanzhixing') }}</p>
              <div style="display: flex;width: 100%;justify-content: center;height: 320px;">
                <el-transfer ref="transfer" target-order="push" style="text-align: left; display: inline-block" v-model="showColumns" :titles="[$t('yincanglie'), $t('xianshilie')]" :format="{ noChecked: '${total}', hasChecked: '${checked}/${total}' }" @change="showColumnsChange" :data="generateTransferColumns">
                  <div slot-scope="{ option }" style="display: flex;justify-content: space-between;width: 100%;" @dragstart="drag($event, option)">
                    <div>{{ $t(option.label) }}</div>
                  </div>
                </el-transfer>
              </div>
              <p style="font-size: 16px; margin: 0 70px 20px">{{ $t('gongdanxiangqing') }}</p>
              <div style="display: flex;width: 100%;justify-content: center;height: 320px;">
                <el-transfer ref="transfer2" target-order="push" style="text-align: left; display: inline-block" v-model="detailShowColumns" :titles="[$t('yincanglie'), $t('xianshilie')]" :format="{ noChecked: '${total}', hasChecked: '${checked}/${total}' }" @change="detailShowColumnsChange" :data="detailColumns">
                  <div slot-scope="{ option }" style="display: flex;justify-content: space-between;width: 100%;" @dragstart="detailDrag($event, option)">
                    <div>{{ $t(option.label) }}</div>
                  </div>
                </el-transfer>
              </div>
            </div>
            <div v-else-if="yt.editObj.type === '60'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('shebeimingcheng')">
                <el-row>
                  <el-col :span="20">
                    <yi_data_select :max="1" :type="'equipment'" :ids.sync="yt.editObj.equipmentIds"></yi_data_select>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '62'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <el-form-item :label="$t('jiaoyanziduan')" required>
                <el-radio v-model="configJson.validateItem" label="ERPNum">{{ $t('lingliaoqitaoshu') }}</el-radio>
                <el-radio v-model="configJson.validateItem" label="feedingNum">{{ $t('touliaoqitaoshuliang') + '/' + $t('feedingQuantity') }}</el-radio>
              </el-form-item>
            </div>

            <div v-else-if="yt.editObj.type === '66'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <el-form-item :label="$t('baoyangdanzidongwancheng')" required>
                <el-select v-model="configJson.finish" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '63'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('baoyangneirongkexuan')">
                <el-select v-model="configJson.isMaintainItemSelectable" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('baoyangdanzidongwancheng')">
                <el-select v-model="configJson.isMaintainBillAutoComplete" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '72'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <el-form-item :label="$t('xianzhishichang(h)')" required>
                <el-input-number v-model="configJson.limitHour" controls-position="right" :min="1" :max="24" :precision="0" :step="1"></el-input-number>
              </el-form-item>
            </div>
          </el-form>
          <div v-if="yt.editObj.type === '0'">
            <el-form class="_form">
              <el-form-item v-for="(item, index) in yt.editObj.productionConfigDetailsList" :key="index" size="mini">
                <el-col :span="0.1">
                  <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(index)"></el-button>
                </el-col>
                <el-col :span="0.2">&nbsp;</el-col>
                <el-col :span="3">
                  <yi_data_select :type="'customerRole'" :ids.sync="item.roleId"></yi_data_select>
                </el-col>
                <el-col :span="4">&nbsp;</el-col>
                <el-col :span="3">
                  <el-input v-model="item.reportingInterval" type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" size="mini"></el-input>
                </el-col>
                <el-col :span="4">&nbsp;</el-col>
                <el-col :span="3">
                  <el-select v-model="item.effect">
                    <el-option :label="$t('xianzhi')" :value="1"></el-option>
                    <el-option :label="$t('tishi')" :value="0"></el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <br />
              <el-form-item size="mini" style="margin-top: -20px;">
                <el-col :span="2">
                  <el-button type="text" icon="el-icon-circle-plus-outline" @click="addItem">
                    {{ $t('zengjiayitiaopeizhixiang') }}
                  </el-button>
                </el-col>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/production/config/create', beforeReq)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 编辑弹窗 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item class="noborder" :label="$t('shengchanpeizhileixing')">
              <yi_dictionary_select disabled type="PRODUCTION_CONFIG_TYPE" :ids.sync="yt.editObj.type"></yi_dictionary_select>
            </el-form-item>

            <template v-if="yt.editObj.type === '0'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <p style="font-size: 18px;">{{ $t('peizhixinxi') }}</p>
              <el-form-item style="margin-left: -30px;" :label="$t('juese')" label-width="130px" required></el-form-item>
              <el-form-item style="margin-left: 150px;" :label="$t('baogongjiange(xiaoshi)')" label-width="130px" required></el-form-item>
              <el-form-item style="margin-left: 70px;" :label="$t('jiangexiaoguo')" label-width="105px" required></el-form-item>
            </template>
            <template v-else-if="yt.editObj.type === '1'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <el-form-item :label="$t('chaochanleixing')" required>
                <el-select v-model="yt.editObj.overType">
                  <el-option :label="$t('bili')" :value="0"></el-option>
                  <el-option :label="$t('shuliang')" :value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('chaochanzhi')" required>
                <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.overValue" size="mini"></el-input>
              </el-form-item>
              <p class="work">
                <i style="margin-left: -270px;" class="yicon yicon-tips">{{ $t('shilishuoming') }}</i>
                <span>{{ $t('bilishuoming') }}</span>
                <span>{{ $t('shuliangshuoming') }}</span>
              </p>
            </template>
            <template v-else-if="defaultTypeList.indexOf(yt.editObj.type) > -1">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </template>
            <template v-else-if="yt.editObj.type === '3'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </template>
            <template v-else-if="yt.editObj.type === '4'">
              <el-form-item :label="$t('mujuzhuangtai')" required>
                <yi_dictionary_select :max="999" multiple :type="'BASIC_MOULD_STATUS'" :ids.sync="yt.editObj.mouldStatus"></yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </template>
            <div v-else-if="yt.editObj.type === '7'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <!--工单限制数量，0或者无不限制数量              -->
              <el-form-item :label="$t('gongdanxianzhishuliang')">
                <el-input-number v-model="configJson.limitNum"></el-input-number>
              </el-form-item>
            </div>
            <template v-else-if="yt.editObj.type === '11'">
              <el-form-item :label="$t('gongdanzhuangtai')" required>
                <yi_dictionary_select :max="8" multiple :type="'PRODUCTION_WO_STATUS'" :ids.sync="yt.editObj.woStatus"></yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </template>

            <div v-else-if="yt.editObj.type === '12'">
              <el-form-item :label="$t('gongdanyouxianji')" required>
                <el-select v-model="yt.editObj.woStartPriority" @change="$forceUpdate()">
                  <el-option :label="$t('gongdanshunxu')" value="0"></el-option>
                  <el-option :label="$t('jihuakaishishijian')" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '13'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '14'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '15'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <div style="display: flex;">
                <el-form-item :label="$t('zuidazhangshu') + '(1-50)'" required>
                  <el-input-number :min="1" :max="50" step-strictly v-model="yt.editObj.overValue"></el-input-number>
                </el-form-item>
              </div>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>

            <div v-else-if="yt.editObj.type === '22'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('shebeimingcheng')">
                <el-row>
                  <el-col :span="20">
                    <yi_data_select ref="equipmentSelect" :multiple="true" :type="'equipment'" :ids.sync="yt.editObj.equipmentIds"></yi_data_select>
                  </el-col>
                  <el-col :span="4">
                    <el-button type="text" @click="selectAll()">{{ $t('quanxuan') }}</el-button>
                  </el-col>
                </el-row>
              </el-form-item>

              <el-form-item :label="$t('baogongren')">
                <yi_data_select :type="'customer_user'" :ids.sync="configJson.reportId"></yi_data_select>
              </el-form-item>

              <el-form-item :label="$t('自动计算产量')">
                <el-checkbox v-model="configJson.checked"></el-checkbox>
              </el-form-item>

              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>

            <div v-else-if="yt.editObj.type === '24'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>

            <div v-else-if="yt.editObj.type === '25'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>

            <div v-else-if="yt.editObj.type === '16'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '29'">
              <el-form-item :label="$t('tongzhiyonghu')" required>
                <yi_data_select :multiple="true" :type="'customer_user'" :ids.sync="yt.editObj.equipmentIds"></yi_data_select>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '31'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <div v-if="yt.editObj.status === 1">
                <el-form-item :label="$t('xieyi')">
                  <el-select v-model="configJson.protocol" style="flex: 1;">
                    <el-option v-for="(h, i) in ['http://', 'https://']" :key="i" :label="h" :value="h"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('zhuji')">
                  <el-input style="flex: 4;" type="text" placeholder="ip:port" v-model="configJson.host"></el-input>
                </el-form-item>
                <el-form-item label="AppKey">
                  <el-input type="text" v-model="configJson.appKey"></el-input>
                </el-form-item>
                <el-form-item label="AppSecret">
                  <el-input type="text" v-model="configJson.appSecret"></el-input>
                </el-form-item>
                <el-form-item :label="$t('jiekoushangxiawenlujin')">
                  <el-input type="text" v-model="configJson.contextPath" placeholder="/"></el-input>
                </el-form-item>
                <el-form-item :label="$t('jiankongdianweiyibiaoshi')">
                  <div style="display: flex;">
                    <el-input type="text" v-model="configJson.indexCode"></el-input>
                    <el-tooltip :content="$t('duogeyongdouhaogekai')" placement="right" style="margin: auto 5px;">
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </div>
                </el-form-item>
              </div>
            </div>
            <div v-else-if="yt.editObj.type === '33'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <p style="font-size: 16px; margin: 0 70px 20px">{{ $t('gongdanzhixing') }}</p>
              <div style="display: flex;width: 100%;justify-content: center;height: 320px;">
                <el-transfer ref="transfer" style="text-align: left; display: inline-block" v-model="showColumns" :titles="[$t('yincanglie'), $t('xianshilie')]" :format="{ noChecked: '${total}', hasChecked: '${checked}/${total}' }" @change="showColumnsChange" :data="generateTransferColumns">
                  <div slot-scope="{ option }" style="display: flex;justify-content: space-between;width: 100%;">
                    <div>{{ $t(option.label) }}</div>
                  </div>
                </el-transfer>
              </div>
              <p style="font-size: 16px; margin: 0 70px 20px">{{ $t('gongdanxiangqing') }}</p>
              <div style="display: flex;width: 100%;justify-content: center;height: 320px;">
                <el-transfer ref="transfer2" style="text-align: left; display: inline-block" v-model="detailShowColumns" :titles="[$t('yincanglie'), $t('xianshilie')]" :format="{ noChecked: '${total}', hasChecked: '${checked}/${total}' }" @change="detailShowColumnsChange" :data="detailColumns"></el-transfer>
              </div>
            </div>

            <div v-else-if="yt.editObj.type === '60'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('shebeimingcheng')">
                <yi_data_select :max="1" :type="'equipment'" :ids.sync="yt.editObj.equipmentIds"></yi_data_select>
              </el-form-item>

              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>

            <div v-else-if="yt.editObj.type === '62'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <el-form-item :label="$t('jiaoyanziduan')" required>
                <el-radio v-model="configJson.validateItem" label="ERPNum">{{ $t('lingliaoqitaoshu') }}</el-radio>
                <el-radio v-model="configJson.validateItem" label="feedingNum">{{ $t('touliaoqitaoshuliang') + '/' + $t('feedingQuantity') }}</el-radio>
              </el-form-item>
            </div>

            <div v-else-if="yt.editObj.type === '66'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <el-form-item :label="$t('保养单自动完成')" required>
                <el-select v-model="configJson.finish" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '63'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('baoyangneirongkexuan')">
                <el-select v-model="configJson.isMaintainItemSelectable" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('baoyangdanzidongwancheng')">
                <el-select v-model="configJson.isMaintainBillAutoComplete" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '72'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <el-form-item :label="$t('xianzhishichang(h)')" required>
                <el-input-number v-model="configJson.limitHour" controls-position="right" :min="1" :max="24" :precision="0" :step="1"></el-input-number>
              </el-form-item>
            </div>
          </el-form>

          <template v-if="yt.editObj.type === '0'">
            <el-form class="_form">
              <el-form-item v-for="(item, index) in yt.editObj.productionConfigDetailsList" :key="index" size="mini">
                <el-col :span="0.1">
                  <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(index)"></el-button>
                </el-col>
                <el-col :span="0.2">&nbsp;</el-col>
                <el-col :span="3">
                  <yi_data_select :type="'customerRole'" :ids.sync="item.roleId"></yi_data_select>
                </el-col>
                <el-col :span="4">&nbsp;</el-col>
                <el-col :span="3">
                  <el-input v-model="item.reportingInterval" type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" size="mini"></el-input>
                </el-col>
                <el-col :span="4">&nbsp;</el-col>
                <el-col :span="3">
                  <el-select v-model="item.effect">
                    <el-option :label="$t('xianzhi')" :value="1"></el-option>
                    <el-option :label="$t('tishi')" :value="0"></el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <br />
              <el-form-item size="mini" style="margin-top: -20px;">
                <el-col :span="2">
                  <el-button type="text" icon="el-icon-circle-plus-outline" @click="addItem">
                    {{ $t('zengjiayitiaopeizhixiang') }}
                  </el-button>
                </el-col>
              </el-form-item>
            </el-form>
          </template>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/production/config/update', beforeEditReq)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_system_configuration_list',
  components: {},
  data() {
    return {
      configJson: {},
      defaultTypeList: ['2', '5', '6', '8', '9', '10', '14', '16', '17', '18', '19', '20', '21', '23', '26', '27', '28', '30', '34', '35', '54', '32', '55', '56', '57', '58', '59', '61', '64', '65', '67', '68', '69', '70', '71','73'],
      columns: [
        {
          label: 'shengchanpeizhileixing',
          prop: 'type',
          type: 'dictionary',
          key: 'PRODUCTION_CONFIG_TYPE'
        },
        {
          label: 'shifouqiyong',
          prop: 'erpNo',
          type: 'slot',
          width: 90
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 180
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 130,
          fixed: 'right'
        }
      ],
      showColumns: [],
      generateTransferColumns: [],
      detailColumns: [],
      detailShowColumns: [],
      selected: {},
      ids: ''
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'createTime desc'
      };
      this.yt.get(1);
      this.yt.isShowPagination = true;
    }, 300);
  },
  watch: {},
  methods: {
    selectAll() {
      let data = this.$refs['equipmentSelect'].items;
      let equipmentIds = [];
      data.forEach(item => {
        equipmentIds.push(item.id);
      });
      console.log(equipmentIds);
      this.yt.editObj.equipmentIds = equipmentIds;
    },
    beforeReq(params) {
      switch (params['type']) {
        case '0': {
          return {
            type: params['type'],
            productionConfigDetailsList: params['productionConfigDetailsList'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '1': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark'],
            overType: params['overType'],
            overValue: params['overValue']
          };
          break;
        }
        case '2': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '3': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '4': {
          return {
            type: params['type'],
            mouldStatus: params['mouldStatus'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '5': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '6': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '7': {
          return {
            type: params['type'],
            status: params['status'],
            configJson: this.configJson,
            remark: params['remark']
          };
          break;
        }
        case '8': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '9': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '10': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '11': {
          return {
            type: params['type'],
            woStatus: params['woStatus'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '12': {
          return {
            type: params['type'],
            woStartPriority: params['woStartPriority'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '13': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '14': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '15': {
          return {
            type: params['type'],
            status: params['status'],
            overValue: params['overValue'],
            remark: params['remark']
          };
          break;
        }
        case '16': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '17': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '18': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '19': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '20': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '21': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '22': {
          return {
            type: params['type'],
            status: params['status'],
            equipmentIds: params['equipmentIds'],
            remark: params['remark'],
            configJson: this.configJson
          };
          break;
        }
        case '23': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '24': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '25': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '26': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '27': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '28': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '29': {
          return {
            type: params['type'],
            status: params['status'],
            equipmentIds: params['equipmentIds'],
            remark: params['remark']
          };
          break;
        }
        case '30': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '54': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '31': {
          const status = params['status'];
          let configJson = {};
          if (status === 1) {
            configJson = this.configJson;
          }
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark'],
            configJson: configJson
          };
          break;
        }
        case '32': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '33': {
          return {
            type: params['type'],
            status: params['status'],
            configJson: this.selected,
            remark: params['remark']
          };
          break;
        }
        case '34': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '35': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '55': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '56': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '57': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '58': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '59': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '60': {
          return {
            type: params['type'],
            status: params['status'],
            equipmentIds: [params['equipmentIds']],
            remark: params['remark']
          };
          break;
        }
        case '61': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '62': {
          let validateItem = { validateItem: this.configJson.validateItem };
          return {
            type: params['type'],
            status: params['status'],
            configJson: validateItem,
            remark: params['remark']
          };
          break;
        }
        case '63': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark'],
            configJson: this.configJson
          };
          break;
        }
        case '64': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '65': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '66': {
          return {
            type: params['type'],
            status: params['status'],
            configJson: this.configJson,
            remark: params['remark']
          };
          break;
        }
        case '67': {
          return {
            type: params['type'],
            status: params['status'],
            configJson: this.configJson,
            remark: params['remark']
          };
          break;
        }
        case '68': {
          return {
            type: params['type'],
            status: params['status'],
            configJson: this.configJson,
            remark: params['remark']
          };
          break;
        }
        case '69': {
          return {
            type: params['type'],
            status: params['status'],
            configJson: this.configJson,
            remark: params['remark']
          };
          break;
        }
        case '70': {
          return {
            type: params['type'],
            status: params['status'],
            configJson: this.configJson,
            remark: params['remark']
          };
          break;
        }
        case '71': {
          return {
            type: params['type'],
            status: params['status'],
            configJson: this.configJson,
            remark: params['remark']
          };
          break;
        }
        case '73': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '72': {
          if (!this.configJson.limitHour) {
            this.$message.error(this.$t('xianzhishichangbitian'));
            return null;
          }
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark'],
            configJson: this.configJson
          };
          break;
        }
      }
    },
    beforeEditReq(params) {
      switch (params['type']) {
        case '31': {
          const status = params['status'];
          let configJson = {};
          if (status === 1) {
            configJson = this.configJson;
          }
          return {
            id: params['id'],
            type: params['type'],
            status: params['status'],
            remark: params['remark'],
            configJson: configJson
          };
          break;
        }
        case '33': {
          return {
            id: params['id'],
            type: params['type'],
            status: params['status'],
            configJson: this.selected,
            remark: params['remark']
          };
          break;
        }
        case '7': {
          return {
            id: params['id'],
            type: params['type'],
            status: params['status'],
            configJson: this.configJson,
            remark: params['remark']
          };
        }
        case '60': {
          return {
            id: params['id'],
            type: params['type'],
            status: params['status'],
            equipmentIds: [params['equipmentIds']],
            remark: params['remark']
          };
          break;
        }
        case '62': {
          let validateItem = { validateItem: this.configJson.validateItem };
          return {
            id: params['id'],
            type: params['type'],
            status: params['status'],
            configJson: validateItem,
            remark: params['remark']
          };
          break;
        }

        case '66': {
          return {
            id: params['id'],
            type: params['type'],
            status: params['status'],
            configJson: this.configJson,
            remark: params['remark']
          };
          break;
        }
        case '72': {
          if (!this.configJson.limitHour) {
            this.$message.error(this.$t('xianzhishichangbitian'));
            return null;
          }
          return {
            id: params['id'],
            type: params['type'],
            status: params['status'],
            remark: params['remark'],
            configJson: this.configJson
          };
          break;
        }
      }
      return params;
    },
    beforeShowEditDialog(editObj) {
      if (editObj.action === 'xinzeng') {
        editObj.type = '0';
        editObj.status = 1;
        editObj.autoCreateMouldAdapterEquipmentData = 0;
        editObj.productionConfigDetailsList = [
          {
            roleId: '',
            reportingInterval: '',
            effect: ''
          }
        ];
      }
      if (editObj.action === 'bianji') {
        this.configJson = editObj.configJson;
        if (editObj.type === '33') {
          this.initAppWoExecutionConfig(editObj);
        } else if (editObj.type === '60') {
          editObj.equipmentIds = parseInt(editObj.equipmentIds[0]);
        } else if (editObj.type === '7') {
          if (this.configJson == null) {
            this.configJson = {};
          }
        }
      }
      return editObj;
    },
    addItem() {
      console.log('this.yt.editObj.productionConfigDetailsList', this.yt.editObj.productionConfigDetailsList);

      this.yt.editObj.productionConfigDetailsList.push({
        roleId: '',
        reportingInterval: '',
        effect: ''
      });
    },
    deleteItem(key) {
      this.yt.editObj.productionConfigDetailsList = this.yt.editObj.productionConfigDetailsList.filter((item, index) => {
        return index !== key;
      });
    },
    dictionaryChange(val) {
      if (val === '6' || val === '8' || val === '9' || val === '10') {
        this.yt.editObj.status = 1;
      }
      if (val === '31') {
        this.$set(this.configJson, 'protocol', 'http://');
      }
      if (val === '33') {
        this.initAppWoExecutionConfig(this.yt.editObj);
      }
    },
    initAppWoExecutionConfig(editObj) {
      this.generateTransferColumns = [];
      this.generateTransferColumns = ['shengchangongdanhao', 'chanpinbianma', 'chanpinmingcheng', 'mujubianhao', 'wangongyuceshijian', 'jihuashuliang', 'yibaogongliangpinshu', 'yanse', 'caizhi', 'guige', 'erpwuliaobianma', 'progress'];
      this.generateTransferColumns = this.generateTransferColumns.map(item => {
        return { label: this.$t(item), key: item };
      });
      this.detailColumns = [];
      this.detailColumns = ['jihuashuliang', 'baogongshuliang', 'yibaogongliangpinshu', 'yibaogongbuliangpinshu', 'shengyushengchanshuliang', 'guige', 'beizhu', 'shijimoqiangshu', 'biaozhun/shijizhouqi(s)', 'shebeimingcheng', 'mujubianhao', 'dangqianliaohao', 'chanpinbianma', 'chanpinmingcheng', 'wuliaomiaoshu', 'chuangjianshijian', 'jihuakaishishijian', 'jihuawanchengshijian', 'shijikaishishijian', 'shijiwanchengshijian'];
      this.detailColumns = this.detailColumns.map(item => {
        return { label: this.$t(item), key: item };
      });
      if (editObj.configJson != undefined && editObj.configJson != null) {
        this.selected = editObj.configJson;
        // 判断数组元素类型并处理
        if (this.selected.list && this.selected.list.length > 0) {
          if (typeof this.selected.list[0] === 'object' && this.selected.list[0].key) {
            // 元素是包含key的对象
            this.showColumns = this.selected.list.map(item => item.key);
          } else if (typeof this.selected.list[0] === 'string') {
            // 元素是字符串
            this.showColumns = this.selected.list;
          }
        }

        // 对detail做同样处理
        if (this.selected.detail && this.selected.detail.length > 0) {
          if (typeof this.selected.detail[0] === 'object' && this.selected.detail[0].key) {
            this.detailShowColumns = this.selected.detail.map(item => item.key);
          } else if (typeof this.selected.detail[0] === 'string') {
            this.detailShowColumns = this.selected.detail;
          }
        }
      } else {
        this.showColumns = this.generateTransferColumns.map(item => {
          return item.key;
        });
        this.detailShowColumns = this.detailColumns.map(item => {
          return item.key;
        });
      }
      this.showColumnsChange();
      this.detailShowColumnsChange();
    },
    showColumnsChange() {
      //保存
      this.$set(this.selected, 'list', this.generateTransferColumns.filter(item => this.showColumns.indexOf(item.key) > -1).map(item => item.key));
    },
    detailShowColumnsChange() {
      //保存
      this.$set(this.selected, 'detail', this.detailColumns.filter(item => this.detailShowColumns.indexOf(item.key) > -1).map(item => item.key));
    }
  }
};
</script>
